import { render, staticRenderFns } from "./QuizCard.vue?vue&type=template&id=b03d3f80&scoped=true&"
import script from "./QuizCard.vue?vue&type=script&lang=js&"
export * from "./QuizCard.vue?vue&type=script&lang=js&"
import style0 from "./QuizCard.vue?vue&type=style&index=0&id=b03d3f80&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b03d3f80",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VRadio,VRadioGroup})
